const sectionReducerDefaultState = {
    section: 'menu'
};

export default (state = sectionReducerDefaultState, action) => {
    switch (action.type) {
        case 'SECTION_MENU':
            return {
                ...state,
                section: 'menu'
            };
        case 'SECTION_BEFORE':
            return {
                ...state,
                section: 'before'
            };
        case 'SECTION_LC':
            return {
                ...state,
                section: 'lc'
            };
        case 'SECTION_UC':
            return {
                ...state,
                section: 'uc'
            };
        case 'SECTION_NUM':
            return {
                ...state,
                section: 'num'
            };
        case 'SECTION_WORDS':
            return {
                ...state,
                section: 'words'
            };
        case 'SECTION_OWN':
            return {
                ...state,
                section: 'own'
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/section.js